import * as REDUX_ACTION from "../../../../../v1/services/redux/actions";

export const handleBilling = (record, action, dispatch, messageApi, user) => {

  let updatedStatus;
  if ( action === "paid") {
    updatedStatus = 4;
  } else if (action === "unpaid") {
    updatedStatus = 2;
  } else {
    console.error("Invalid action or status");
  }

  if (updatedStatus !== undefined) {
    const role = user?.uroleid
    const updatedItems = { ...record, status: updatedStatus };
    delete updatedItems.key;
    delete updatedItems.company_name;
    
    const updatedRecord = {
      billid: record.billid,
      updatedBy: user?.memid,
      items: updatedItems,
    };

    messageApi.open({
      type: "loading",
      content: "Updating Status...",
      duration: 0,
    });

    dispatch(
      REDUX_ACTION.v1_billing.update_billing_request(updatedRecord, role, () => {
        messageApi.destroy();
      })
    );
  } else {
    console.error("Invalid action or status");
  }
};
